@if(theme === 'intennse-side'){
  @if (tie){
    <div [ngClass]="theme">
      <div class="score-box" [ngStyle]="{'background-color': match.matchStatus === 'COMPLETED' ? getWinningTeamColor(tie) : 'rgba(0, 0, 0, 0.6)'}">
        <ion-title>{{ tie?.tieFormat.collectionDefinitions?.[0].collectionName }}</ion-title>

        <div class="card">
          <div class="team-name">
            {{ getTeamName(1).slice(0, 3) }}
          </div>
          <div class="team-score" *ngIf="match.matchStatus != 'TBP'">
            <div class="checkmark">
              <ion-icon *ngIf="match.matchStatus==='COMPLETED' && match.winningSide === 1" class="icon win-checkmark" color="light" name="checkmark"></ion-icon>
              <ion-icon *ngIf="match.matchStatus === 'IN_PROGRESS' && server?.sideNumber === 1" slot="start" name="ellipse" color="BOLT"></ion-icon>
              <span class="score-number"> {{ getScore(tie?.score)[0] }} </span>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="team-name">
            {{ getTeamName(2).slice(0, 3) }}
          </div>
          <div class="team-score" *ngIf="match.matchStatus != 'TBP'">
            <div class="checkmark">
              <ion-icon *ngIf="match.matchStatus==='COMPLETED' && match.winningSide === 2" class="icon win-checkmark" color="light" name="checkmark"></ion-icon>
              <ion-icon *ngIf="match.matchStatus === 'IN_PROGRESS' && server?.sideNumber === 2" slot="start" name="ellipse" color="BOLT"></ion-icon>
              <span class="score-number"> {{ getScore(tie?.score)[1] }} </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

 @else if(theme === 'intennse-bottom'){
<div class="intennse-scoreboard">
  @if (tie){
  <div class="team-name" [ngStyle]="{ backgroundColor: side1Color }">
    {{ getTeamName(1).slice(0, 3) }}
    {{ getTeamName(1) | truncate }}
  </div>

  <div class="score-box">
    <span> {{ getScore(tie?.score)[0] }} </span>
  </div>

  <div class="bolt-time">
    @if (setTimer) {
    <strong>
      <app-stopwatch
        [showButtons]="false"
        [match]="match"
        [clockInputValue]="setTimer"
        [displayType]="'PLAIN'"
      ></app-stopwatch>
    </strong>
    }
    <span>bolt: {{ match.score?.sets?.length }}</span>
  </div>
  <div class="serve-time">
    @if (pointBreakTimer) {<strong>
      :<app-stopwatch
        [showButtons]="false"
        [match]="match"
        [clockInputValue]="pointBreakTimer"
        [displayType]="'PLAIN'"
      ></app-stopwatch> </strong
    >}

    <span>Serve</span>
  </div>
  <div class="score-box">
    <span>{{ getScore(tie?.score)[1] }} </span>
  </div>
  <div class="team-name" [ngStyle]="{ backgroundColor: side2Color }">
    {{ getTeamName(2) | truncate }}
  </div>
  }
</div>
} @else {
<div [ngClass]="theme">
  @if (theme !== 'dinko' && theme !== 'split-videoboard') {
  <div class="court" [ngClass]="{'fixed-width': isIndividualMatch}">
    @if (tie) {
      #
    }
      {{ scoreboardService.getCourtName(match) }}
  </div>
  }

  <div class="container" [ngClass]="{'fixed-width': isIndividualMatch}">
    @if (theme === 'dinko') {
    <div class="header">
      <div class="left-col"></div>
      <div class="points-col">GAMES</div>

      <div class="points-col">POINTS</div>
    </div>
    }

    <div class="wrapper">
      <div class="flex-row">
        @if (theme === 'split-videoboard') {
        <div class="text-align-middle">
          {{ match.matchType }}{{ match.collectionPosition }}
        </div>
        }
        <div id="participants" class="flex-column participant wrap-text">
          @for (side of match.sides; let i = $index; track i) {
          <div class="text-align-middle">
            @if (theme === 'dinko' || theme === 'split-videoboard') {
            {{ getLastNames(i + 1) }} ({{ getTeamName(i + 1) }}) } @else { @if
            (match.matchType === 'D') {
            <span class="doubles">
              {{ getParticipantName(side.players[0].participant, i + 1) }}
              <span *ngIf="tie" class="team">({{ getTeamName(i + 1) }})</span
              ><br />
              {{ getParticipantName(side.players[1].participant, i + 1) }}
              <span *ngIf="tie" class="team">({{ getTeamName(i + 1) }})</span>
            </span>
            } @else {
            <span class="singles">
              {{ getParticipantName(side.players[0].participant, i + 1) }}
              <span *ngIf="tie" class="team">({{ getTeamName(i + 1) }})</span
              ><br />
            </span>
            } }
          </div>
          }
        </div>

        <!-- Server / Winner -->
        <div class="flex-column" style="text-align: right">
          <div class="top-point">
            @if (match.winningSide === 1) {
            <ion-icon
              class="icon winning-checkmark"
              name="checkmark"
            ></ion-icon>
            } @else if (server?.sideNumber === 1 && match.matchStatus
            ==='IN_PROGRESS') {
            <div class="server">
              @if (match.discipline === 'PICKLEBALL') {
              <span>{{ match.score.server.serverNumber }}</span>
              }
            </div>
            }
          </div>

          <div>
            @if (match.winningSide === 2) {
            <ion-icon
              class="icon winning-checkmark"
              name="checkmark"
            ></ion-icon>
            } @else if (server?.sideNumber === 2 && match.matchStatus
            ==='IN_PROGRESS') {
            <div class="server">
              @if (match.discipline === 'PICKLEBALL') {
              <span>{{ match.score.server.serverNumber }}</span>
              }
            </div>
            }
          </div>
        </div>

        <!-- Retirement / Incomplete -->
        @if (isRetiredOrIncomplete) {
        <div class="flex-column" style="text-align: right">
          <div class="scorebox" style="width: auto">
            {{ statusSide1 }}
          </div>

          <div class="scorebox" style="width: auto">
            {{ statusSide2 }}
          </div>
        </div>
        }

        <!-- Games -->
        @if(match?.score?.sets?.length;) { @if (theme === 'dinko') {
        <div id="sets-won" class="flex-column">
          <div class="sets-won">
            {{ setsWon(1) }}
          </div>

          <div class="sets-won">
            {{ setsWon(2) }}
          </div>
        </div>
        } @else { @for (set of match.score.sets; let i = $index; track i;) { @if
        (match.discipline !== 'PICKLEBALL' || set.winningSide) {
        <div id="games" class="flex-column ion-text-center">
          <div class="scorebox" [class]="{ winning: set.winningSide === 1 }">
            {{ match | gameScore : { setIndex: i, sideNumber: 1 }
            }}<sup>{{ scoreboardService.getTiebreakScore(match, i, 1) }}</sup>
          </div>

          <div class="scorebox" [class]="{ winning: set.winningSide === 2 }">
            {{ match | gameScore : { setIndex: i, sideNumber: 2 }
            }}<sup>{{ scoreboardService.getTiebreakScore(match, i, 2) }}</sup>
          </div>
        </div>
        } } } }

        <!-- Points -->
        @if (showPoints) {
        <div id="points" class="flex-column">
          <div class="points points-top">
            {{ pointScoreSide1 }}
          </div>

          <div class="points points-bottom">
            {{ pointScoreSide2 }}
          </div>
        </div>
        }
      </div>
    </div>

    @if (pointBreakTimer) {
    <div class="stopwatch">
      <div class="label">SERVE</div>

      <div class="time">
        <app-stopwatch
          [showButtons]="false"
          [match]="match"
          [clockInputValue]="pointBreakTimer"
          [displayType]="'PLAIN'"
        ></app-stopwatch>
      </div>
    </div>
    } @if (setTimer) {
    <div class="stopwatch">
      <div class="label">BOLT</div>

      <div class="time">
        <app-stopwatch
          [showButtons]="false"
          [match]="match"
          [clockInputValue]="setTimer"
          [displayType]="'PLAIN'"
        ></app-stopwatch>
      </div>
    </div>
    }
  </div>
</div>
}
